<template>
  <section class="blog-ad-container">
    <h3>Blog in Ad Report</h3>
    <div class="top-btn">
      <v-button
        gray
        @click="handleExportList">Export List</v-button>
      <v-button
        gray
        @click="exportList">Export</v-button>
    </div>
    <div class="form-item">
      <span>Date</span>
      <v-date-picker
        v-model="date"
        type="daterange"
        @change="filterData" />
    </div>

    <div class="transparent">
      <el-table
        :data="adReportList"
        stripe
        style="width: 100%">
        <el-table-column
          label="Post Name">
          <template slot-scope="scope">
            <span>
              {{ scope.row.post_name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="Category Name">
          <template slot-scope="scope">
            <span>
              {{ scope.row.category_name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="Device">
          <template slot-scope="scope">
            {{ scope.row.device }}
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="Created Time"></el-table-column>
      </el-table>

    </div>
    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />

  </section>
</template>
<script>
import { getCategoryAdReport, exportCategoryAd } from '@/api/news'
import { downloadFile } from '@/utils/download'
import MixinOptions from '@/mixins/options'
import MixinOtherReport from '@/mixins/other-report'
export default {
  name: 'BlogAdReportContainer',
  mixins: [MixinOptions,MixinOtherReport],
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      adReportList: [],
      date: [],
      report_type:17
    }
  },
  computed: {
    dateParams() {
      const hasDate = this.date && this.date.length >= 2
      return {
        start_date: hasDate? this.date[0]: '',
        end_date: hasDate? this.date[1]: '',
      }
    },
    report_params(){
      const hasDate = this.date && this.date.length >= 2
      return {
        start_date: hasDate? this.date[0]: '',
        end_date: hasDate? this.date[1]: '',
      }
    },
  },
  mounted() {
    this.network().getCategoryAdReport()
  },
  methods: {
    onExport() {
      this.network().exportCategoryAd()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getCategoryAdReport()
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getCategoryAdReport()
    },
    network() {
      return {
        getCategoryAdReport: async () => {
          const { data } = await getCategoryAdReport({
            ...this.dateParams,
            page: this.pageConfig.currentPage
          })
          this.adReportList = data.data
          this.pageConfig.total = data.meta.total
        },
        exportCategoryAd: async () => {
          const res = await exportCategoryAd(this.dateParams)
          downloadFile(res)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.blog-ad-container {
    position: relative;
    .top-btn {
        position: absolute;
        top: 0;
        right: 0;
    }
    .form-item {
        width: 300px;
    }
}
</style>